// export const url_server = 'http://localhost:3003';
export const url_server = 'https://www.machupicchu.gob.pe:8000';
// export const url_server = 'http://181.176.220.83:8000';
// export const url_server = 'https://181.176.220.83:8000';
// export const url_server = 'https://www.culturacusco.gob.pe:8000';
// export const url_server = 'http://localhost:3003';
// export const url_server = 'http://172.22.222.244:3003'; // DEV - ZeroTier - Thinkpad Javier
